import { useState, useEffect, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Pages/Header/Header';
import Footer from '../Pages/Footer/Footer';

const excludeHeaderFooterRoutes = ['/luxury-interior-design-company','/interior-designer-in-gurgaon','/residential-interior-design'];


const Layout = ({ children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  // Simulate tracking children loading state
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false); // Set loading to false after a delay or when children are loaded
    }, 500); // Adjust the timeout based on expected loading duration
    return () => clearTimeout(timeout); // Clean up timeout on component unmount
  }, [children]);

  // Exclude Header and Footer for specific routes

  const shouldExcludeHeaderFooter = excludeHeaderFooterRoutes.includes(location.pathname);

  return (
    <>
      {!shouldExcludeHeaderFooter && (
        <Suspense fallback={<div></div>}>
          <Header />
        </Suspense>
      )}
      <main>
        <Suspense fallback={<div></div>}>
          {children}
        </Suspense>
      </main>
      {!shouldExcludeHeaderFooter && !isLoading && (
        <Suspense fallback={<div></div>}>
          <Footer />
        </Suspense>
      )}
    </>
  );
};

export default Layout;
